import { TFunction } from 'i18next'

export const STATUS_PILL_KEYS = ['BLOCKED', 'NEEDS_ATTENTION', 'SLOW', 'ON_TRACK', 'PENDING', 'COMPLETED', 'REJECTED'] as const
export type StatusPillKey = (typeof STATUS_PILL_KEYS)[number]

const AI_ASSESSMENT_KEYS: readonly StatusPillKey[] = ['ON_TRACK', 'SLOW', 'NEEDS_ATTENTION']

// Structural on purpose: both the request-grid rows and the server export's list item satisfy it without
// sharing a nominal type across the FE/BE boundary. `operationalStatusAssessment` is the stored AI value.
export type StatusPillRow = {
  status: 'pending' | 'completed' | 'rejected' | 'paused'
  paused: boolean
  hasErroredTasks: boolean
  hasRejectedTasks: boolean
  operationalStatusAssessment: 'ON_TRACK' | 'SLOW' | 'NEEDS_ATTENTION' | 'BLOCKED' | null
}

export const getStatusPillKey = (row: StatusPillRow): StatusPillKey => {
  if (row.status === 'completed') return 'COMPLETED'
  if (row.status === 'rejected') return 'REJECTED'
  // Short-circuit BLOCKED so the pill flips immediately rather than waiting up to ~1h for the next AI refresh.
  if (row.paused || row.hasErroredTasks || row.hasRejectedTasks) return 'BLOCKED'
  // Stored BLOCKED without a live signal is stale (user unblocked since last refresh) — drop to PENDING.
  if (row.operationalStatusAssessment && row.operationalStatusAssessment !== 'BLOCKED') return row.operationalStatusAssessment
  return 'PENDING'
}

export const isAiSetPillKey = (row: StatusPillRow): boolean => AI_ASSESSMENT_KEYS.includes(getStatusPillKey(row))

export const getStatusPillLabel = (pillKey: StatusPillKey, t: TFunction<'requests'>): string =>
  t(`table-column.status-pill.${pillKey}`)
